'use client';

import { Controller } from 'react-hook-form';
import { AmountInput } from '@/shared/ui/amount-input';
import { FormFieldProps } from './types';
import { mergeRefs } from './utils/mergeRefs';
import { parseRulesForInputAttributes } from './utils/parseRulesForInputAttributes';

type Props = FormFieldProps<typeof AmountInput>;
export const FormAmountInput = ({
    id,
    name,
    control,
    defaultValue,
    disabled,
    rules,
    shouldUnregister,
    ref,
    type,
    value,
    disableMinus,
    disablePlus,
    ...props
}: Props) => {
    if (type === 'radio') {
        return (
            <AmountInput
                type={type}
                value={value}
                disableMinus={disableMinus}
                disablePlus={disablePlus}
                {...props}
            />
        );
    }

    return (
        <Controller
            {...{ name, control, defaultValue, disabled, rules, shouldUnregister }}
            render={({ field: { ref: fieldRef, onChange, ...field } }) => {
                return (
                    <AmountInput
                        ref={mergeRefs([fieldRef, ref])}
                        id={id || name}
                        {...parseRulesForInputAttributes(rules)}
                        {...field}
                        onChange={(e) => onChange(parseFloat(e.target.value))}
                        disableMinus={disableMinus}
                        disablePlus={disablePlus}
                        {...props}
                    />
                );
            }}
        />
    );
};
